import React, { useContext } from 'react';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setVehicle } from '../actions/actionsAppTest';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationOptionsIfNeeded, fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import TestVehicle from '../components/testCriteria/TestVehicle';

export default function ContTestVehicle() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeVehicle(vehicle) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, false);
    fetchSimulationOptionsIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, null, false);
    fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, null, false);
    dispatch(setVehicle(vehicle));
  }

  return (
    <TestVehicle
      context={globalstate.testCriteria.context}
      data={globalstate.testCriteria.vehicle}
      settings={globalstate.settings}
      onChangeVehicle={onChangeVehicle}
    />
  );
}
